export default __webpack_public_path__ + "static/media/Metropolis-Regular.4a73bd52.woff";